<template>
  <div class="base-input">
    <label v-if="label" :for="uid">
      {{ label }}
      <span v-if="required" data-test-id="base-input__required-icon">*</span>
    </label>
    <input
      :id="uid"
      :placeholder="getPlaceholder"
      :value="modelValue"
      @input="onInputEvent"
      v-bind="attrs"
      :aria-describedby="error ? `${uid}-error` : null"
      :aria-invalid="error ? true : null"
      data-test-id="base-input__input"
    />
    <p
      v-if="error"
      aria-live="assetive"
      :id="`${uid}-error`"
      data-test-id="base-input__error"
    >
      <i class="icon-nav-warning" />
      {{ error }}
    </p>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "base-input",

  props: {
    label: {
      type: [String, Number],
      default: "",
    },
    showPlaceholder: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: [String, Number],
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
  },

  setup(props, { emit, attrs }) {
    const uid = Date.now().toString(36) + Math.random().toString(36).substr(2);

    const getPlaceholder = computed(() => {
      if (!props.showPlaceholder) {
        return "";
      }

      if (props.placeholder == "") return props.label;

      return props.placeholder;
    });

    const onInputEvent = ($event) => {
      emit("update:modelValue", $event.target.value);
    };

    return {
      uid,
      getPlaceholder,
      onInputEvent,
      attrs,
    };
  },
});
</script>

<style lang="scss" scoped>
.base-input {
  padding: 8px 0;

  label {
    font-family: "text-bold";
    font-size: toRem(13px);
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
    color: var(--insights-color-17);
    text-transform: uppercase;
  }

  input {
    border: none;
    width: 100%;
    border-radius: 3px;
    border: 2px solid var(--insights-color-15);
    font-size: toRem(16px);
    padding: 7px 10px;

    &:focus {
      outline: none;
    }

    &::placeholder {
      font-family: "text-regular";
      font-size: toRem(16px);
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */
      letter-spacing: 0.5px;
      color: var(--insights-color-11);
    }
  }

  p {
    margin: 0;
    color: var(--insights-color-27);
    font-family: "text-bold";
    font-size: toRem(13px);
    font-style: normal;
    line-height: 16px;
    display: flex;
    align-items: center;
    gap: 5px;
  }
}
</style>
